import moment from 'moment';

const SubscriptionStatus = {
  trial: 'Trial',
  free: 'Free',
  active: 'Active',
  suspended: 'Suspended',
  deleted: 'Deleted',
  removed: 'Removed',
  cancelled: 'Cancelled',
  purged: 'Purged',
  failed: 'Failed',
};

const SubscriptionStatusArabic = {
  trial: 'محاكمة',
  free: 'حر',
  active: 'نشيط',
  suspended: 'موقوف عن العمل',
  deleted: 'تم الحذف',
  removed: 'إزالة',
  cancelled: 'ألغيت',
  purged: 'تطهير',
  created: 'باءت بالفشل',
};

const SubscriptionStatusNorwegian = {
  trial: 'Prøve',
  free: 'Gratis',
  active: 'Aktiv',
  suspended: 'Suspendert',
  deleted: 'Slettet',
  removed: 'Fjernet',
  cancelled: 'Avbrutt',
  purged: 'Renset',
  created: 'Mislyktes',
};

const SubscriptionStatusSerbian = {
  trial: 'Суђење',
  free: 'бесплатно',
  active: 'Активно',
  suspended: 'Суспендован',
  deleted: 'Избрисан',
  removed: 'Уклоњено',
  cancelled: 'Отказано',
  purged: 'Очишћено',
  created: 'Није успео',
};

const SubscriptionStatusDutch = {
  trial: 'Proces',
  free: 'Vrij',
  active: 'Actief',
  suspended: 'Opgeschort',
  deleted: 'verwijderd',
  removed: 'VERWIJDERD',
  cancelled: 'Geannuleerd',
  purged: 'Gezuiverd',
  created: 'mislukt',
};

const SubscriptionStatusBurmese = {
  trial: 'တရားခွင်',
  free: 'အခမဲ့ဖြစ်သည်',
  active: 'သွက်လက်တယ်',
  suspended: 'ရပ်ဆိုင်းလိုက်သည်',
  deleted: 'ဖျက်လိုက်သည်',
  removed: 'ဖယ်ရှားလိုက်သည်',
  cancelled: 'ပယ်ဖျက်လိုက်သည်',
  purged: 'သုတ်သင်ရှင်းလင်းသည်',
  created: 'မအောင်မြင်ပါ',
};

const SubscriptionStatusMalay = {
  trial: 'Percubaan',
  free: 'Percuma',
  active: 'Aktif',
  suspended: 'Digantung',
  deleted: 'Dipadam',
  removed: 'Dibuang',
  cancelled: 'Dibatalkan',
  purged: 'Dibersihkan',
  created: 'Gagal',
};

const SubscriptionStatusSwedish = {
  trial: 'Rättegång',
  free: 'Fri',
  active: 'Aktiva',
  suspended: 'Upphängd',
  deleted: 'Raderade',
  removed: 'Tog bort',
  cancelled: 'Inställt',
  purged: 'Rensad',
  created: 'Misslyckades',
};

const SubscriptionStatusMozambique = {
  trial: 'Experimentar',
  free: 'Gratuitamente',
  active: 'Ativo',
  suspended: 'Suspenso',
  deleted: 'Excluído',
  removed: 'Descartado',
  cancelled: 'Cancelar',
  purged: 'Purga',
  created: 'Falhou',
};

const Frequency = {
  daily: 'Daily',
  weekly: 'Weekly',
  fortnightly: 'Fortnightly',
  monthly: 'Monthly',
};

const FrequencyArabic = {
  daily: 'اليومي',
  weekly: 'أسبوعي',
  fortnightly: 'كل أسبوعين',
  monthly: 'شهريا',
};

const FrequencyNorwegian = {
  daily: 'Daglig',
  weekly: 'Ukentlig',
  fortnightly: 'Hver fjortende dag',
  monthly: 'Månedlig',
};

const FrequencySerbian = {
  daily: 'дневно',
  weekly: 'недељно',
  fortnightly: 'двонедељно',
  monthly: 'месечно',
};

const FrequencyDutch = {
  daily: 'dagelijks',
  weekly: 'wekelijks',
  fortnightly: 'tweewekelijksо',
  monthly: 'maandelijks',
};

const FrequencyBurmese = {
  daily: 'နေ့စဉ်',
  weekly: 'အပတ်စဉ်',
  fortnightly: 'နှစ်ကြိမ်',
  monthly: 'လစဉ်',
};

const FrequencyMalay = {
  daily: 'Harian',
  weekly: 'Mingguan',
  fortnightly: 'Setiap 2 Minggu',
  monthly: 'Bulanan',
};

const FrequencySwedish = {
  daily: 'Dagligen',
  weekly: 'Varje vecka',
  fortnightly: 'Var fjortonde dag',
  monthly: 'En gång i månaden',
};

const FrequencyMozambique = {
  daily: 'Diário',
  weekly: 'Semanalmente',
  fortnightly: 'Quinzenal',
  monthly: 'Por mês',
};

const TransactionStatus = {
  INSUFFICIENT_FUNDS: 'Insufficient Funds',
  INSUFFICIENT_BALANCE: 'Insufficient Balance',
  CHARGED: 'Charged',
  REFUNDED: 'Refunded',
  ERROR: 'Error',
  SYSTEM_ERROR: 'System Error',
  FAILED: 'Failed',
};

const TransactionStatusArabic = {
  INSUFFICIENT_FUNDS: 'رصيد غير كاف',
  INSUFFICIENT_BALANCE: 'رصيد غير كاف',
  CHARGED: 'متهم',
  REFUNDED: 'معاد',
  ERROR: 'خطأ',
  SYSTEM_ERROR: 'خطأ في النظام',
  FAILED: 'باءت بالفشل',
};

const TransactionStatusNorwegian = {
  INSUFFICIENT_FUNDS: 'Utilstrekkelig Fond',
  INSUFFICIENT_BALANCE: 'Utilstrekkelig Balanse',
  CHARGED: 'Ladet',
  REFUNDED: 'Refunderes',
  ERROR: 'Feil',
  SYSTEM_ERROR: 'System feil',
  FAILED: 'Mislyktes',
};

const TransactionStatusSerbian = {
  INSUFFICIENT_FUNDS: 'Недовољно средстава',
  INSUFFICIENT_BALANCE: 'Недовољан баланс',
  CHARGED: 'Наплаћено',
  REFUNDED: 'Рефундед',
  ERROR: 'Грешка',
  SYSTEM_ERROR: 'Грешка у систему',
  FAILED: 'Није успео',
};

const TransactionStatusDutch = {
  INSUFFICIENT_FUNDS: 'Onvoldoende middelen',
  INSUFFICIENT_BALANCE: 'Onvoldoende saldo',
  CHARGED: 'Opgeladen',
  REFUNDED: 'Terugbetaald',
  ERROR: 'Fout',
  SYSTEM_ERROR: 'Systeemfout',
  FAILED: 'Mislukt',
};

const TransactionStatusBurmese = {
  INSUFFICIENT_FUNDS: 'ငွေကြေးမလုံလောက်',
  INSUFFICIENT_BALANCE: 'Balance မလုံလောက်ပါ',
  CHARGED: 'ငွေတောင်းတယ်',
  REFUNDED: 'ငွေပြန်အမ်းသည်',
  ERROR: 'အမှား',
  SYSTEM_ERROR: 'စနစ်အမှား',
  FAILED: 'မအောင်မြင်ပါ',
};

const TransactionStatusMalay = {
  INSUFFICIENT_FUNDS: 'Kekurangan Dana',
  INSUFFICIENT_BALANCE: 'Kekurangan Baki',
  CHARGED: 'Caj',
  REFUNDED: 'Dikembalikan',
  ERROR: 'Kesalahan',
  SYSTEM_ERROR: 'Kesalahan Sistem',
  FAILED: 'Gagal',
};

const TransactionStatusSwedish = {
  INSUFFICIENT_FUNDS: 'Otillräckliga medel',
  INSUFFICIENT_BALANCE: 'Otillräcklig balans',
  CHARGED: 'Laddad',
  REFUNDED: 'Återbetalas',
  ERROR: 'Fel',
  SYSTEM_ERROR: 'Systemfel',
  FAILED: 'Misslyckades',
};

const TransactionStatusMozambique = {
  INSUFFICIENT_FUNDS: 'Fundos insuficientes',
  INSUFFICIENT_BALANCE: 'Saldo insuficiente',
  CHARGED: 'Cobrado',
  REFUNDED: 'Devolveu',
  ERROR: 'Erro',
  SYSTEM_ERROR: 'Erro no sistema',
  FAILED: 'Falhou',
};

const OperatorCountry = [
  { value: 'ARE', label: 'UAE', img: '/flags/uae.png' }, // UAE
  { value: 'BHR', label: 'Bahrain', img: '/flags/bahrain.jpg' }, // BAHRAIN
  // { "value": "DNK", "label": "Denmark", "img": "/flags/denmark.png" }, //Denmark
  { value: 'IRL', label: 'Ireland', img: '/flags/ireland.png' }, // IRELAND
  { value: 'IRQ', label: 'Iraq', img: '/flags/iraq.png' }, // IRAQ
  { value: 'JOR', label: 'Jordan', img: '/flags/jordan.png' }, // JORDAN
  { value: 'KWT', label: 'Kuwait', img: '/flags/kuwait.png' }, // Kuwait
  // { "value": "LBN", "label": "Lebanon", "img": "/flags/lebanon.png" }, //Lebanon
  { value: 'LKA', label: 'Sri Langka', img: '/flags/sri-lanka.png' }, // sri langka
  // { "value": "MAR", "label": "Morroco", "img": "/flags/morroco.png" }, //morroco
  { value: 'MMR', label: 'Myanmar', img: '/flags/myanmar.png' }, // Myanmar
  { value: 'MNG', label: 'Mongolia', img: '/flags/mongolia.png' }, // mongolia
  { value: 'MYS', label: 'Malaysia', img: '/flags/malaysia.png' }, // malaysia
  { value: 'MOZ', label: 'Mozambique', img: '/flags/mz.png' }, // morroco
  { value: 'NOR', label: 'Norway', img: '/flags/norway.png' }, // Norway
  // { "value": "PST", "label": "Palestine", "img": "/flags/palestine.jpg" }, //palestine
  { value: 'SRB', label: 'Serbia', img: '/flags/serbia.png' }, // SERBIA
  { value: 'SAU', label: 'Saudi Arabia', img: '/flags/sa.png' }, // Saudi
  // { "value": "SDN", "label": "Sudan", "img": "/flags/sudan.png" }, //SUDAN
  { value: 'SWE', label: 'Sweden', img: '/flags/sweden.png' }, // SWEDEN
  // { "value": "SSD", "label": "South Sudan", "img": "/flags/south-sudan.png" }, //SOUTH-SUDAN
  { value: 'GBR', label: 'UK', img: '/flags/uk.png' }, // UK
  { value: 'NGA', label: 'Nigeria', img: '/flags/nigeria.png' }, // UK
  { value: 'QA', label: 'Qatar', img: '/flags/qatar.png' }, // Qatar
  { value: 'LY', label: 'Libya', img: '/flags/libya.png' }, // Libya
];

const OperatorPrefix = [
  {
    prefix: '94',
    value: 'axiata-lk',
    label: 'Axiata Dialog',
    country: 'LKA',
    img: '/operatorLogos/dialog.png',
  },
  {
    prefix: '971',
    value: 'etisalat-ae',
    label: 'Etisalat',
    country: 'ARE',
    img: '/operatorLogos/etisalat.svg',
  },
  {
    prefix: '966',
    value: 'zain-sa',
    label: 'Zain',
    country: 'SAU',
    img: '/operatorLogos/zain-sa.svg',
  },
  {
    prefix: '964',
    value: 'zain-iq',
    label: 'Zain',
    country: 'IRQ',
    img: '/operatorLogos/zain.jpg',
  },
  /* { "prefix": "961", "value": "zain-touch", "label": "Zain", "country": "LBN", "img": "/operatorLogos/zain.jpg" }, */
  {
    prefix: '962',
    value: 'zain-jo',
    label: 'Zain',
    country: 'JOR',
    img: '/operatorLogos/zain.jpg',
  },
  /* { "prefix": "970", "value": "jawwal-pl", "label": "Jawwal", "country": "PST", "img": "/operatorLogos/jawwal.png" }, */
  {
    prefix: '973',
    value: 'zain-bh',
    label: 'Zain',
    country: 'BHR',
    img: '/operatorLogos/zain.jpg',
  },
  {
    prefix: '965',
    value: 'zain-kw',
    label: 'Zain',
    country: 'KWT',
    img: '/operatorLogos/zain.jpg',
  },
  {
    prefix: '46',
    value: 'telenor-se',
    label: 'Telenor',
    country: 'SWE',
    img: '/operatorLogos/telenor.svg',
  },
  {
    prefix: '95',
    value: 'telenor-mm',
    label: 'Atom',
    country: 'MMR',
    img: '/operatorLogos/atome.png',
  },
  /* { "prefix": "45", "value": "telenor-dk", "label": "Telenor", "country": "DNK", "img": "/operatorLogos/telenor.svg" } , */
  {
    prefix: '381',
    value: 'telenor-rs',
    label: 'Yettel',
    country: 'SRB',
    img: '/operatorLogos/yettel.png',
  },
  {
    prefix: '47',
    value: 'telenor-no',
    label: 'Telenor',
    country: 'NOR',
    img: '/operatorLogos/telenor.svg',
  },
  // { "prefix": "60", "value": "telenor-digi", "label": "Telenor", "country": "MYS", "img": "/operatorLogos/telenor-digi.png" },
  {
    prefix: '60',
    value: 'telenor-digi',
    label: 'CelcomDigi',
    country: 'MYS',
    img: '/operatorLogos/celcomdigi.png',
  },
  {
    prefix: '965',
    value: 'ooredoo-kw',
    label: 'Ooredoo',
    country: 'KWT',
    img: '/operatorLogos/ooredoo.svg',
  },
  /* https://sla-ltd.atlassian.net/browse/ALACRITY-1604 */
  /* { "prefix": "965", "value": "stc-kw", "label": "STC", "country": "KWT", "img": "/operatorLogos/stc.png" }, */
  {
    prefix: '353',
    value: 'vf-ie',
    label: 'Vodafone',
    country: 'IRL',
    img: '/operatorLogos/vodafone.jpg',
  },
  {
    prefix: '44',
    value: 'voda-uk',
    label: 'Vodafone',
    country: 'GBR',
    img: '/operatorLogos/vodafone.jpg',
  },
  /* { "prefix": "249", "value": "zain-sd", "label": "Zain", "country": "SDN", "img": "/operatorLogos/zain.jpg" }, */
  {
    prefix: '44',
    value: 'three-uk',
    label: 'Three',
    country: 'GBR',
    img: '/operatorLogos/three.svg',
  },
  {
    prefix: '44',
    value: 'o2-uk',
    label: 'O2',
    country: 'GBR',
    img: '/operatorLogos/o2.png',
  },
  {
    prefix: '44',
    value: 'ee-uk',
    label: 'EE',
    country: 'GBR',
    img: '/operatorLogos/ee-uk.png',
  },
  {
    prefix: '44',
    value: 'eetmo-uk',
    label: 'Fonix',
    country: 'GBR',
    img: '/operatorLogos/fonix.png',
  },

  // 29-8-22 update for new operators
  {
    prefix: '353',
    value: 'three-ie',
    label: 'Three',
    country: 'IRL',
    img: '/operatorLogos/three.svg',
  },
  {
    prefix: '976',
    value: 'unitel-mn',
    label: 'Unitel',
    country: 'MNG',
    img: '/operatorLogos/unitel-mn.png',
  },
  {
    prefix: '258',
    value: 'viettel-mz',
    label: 'Movitel',
    country: 'MOZ',
    img: '/operatorLogos/viettel-mz.png',
  },
  {
    prefix: '60',
    value: 'maxis-my',
    label: 'Maxis',
    country: 'MYS',
    img: '/operatorLogos/maxis.png',
  },
  /* { "prefix": "211", "value": "zain-ss", "label": "Zain", "country": "SSD", "img": "/operatorLogos/zain-ss.jpg" } , */
  /* { "prefix": "212", "value": "inwi", "label": "Morrocco", "country": "MAR", "img": "/operatorLogos/inwi.png" }, */
  {
    prefix: '60',
    value: 'umobile-my',
    label: 'U Mobile',
    country: 'MYS',
    img: '/operatorLogos/umobile.png',
  },
  {
    prefix: '234',
    value: 'mobile-ng',
    label: '9Mobile Nigeria',
    country: 'NGA',
    img: '/operatorLogos/9mobile.png',
  },

  // 30-08-2023 add for Qatar
  {
    prefix: '974',
    value: 'vf-qa',
    label: 'Vodafone',
    country: 'QA',
    img: '/operatorLogos/vodafone.jpg',
  },

  // 28-05-24 add for Libya operators
  {
    prefix: '218',
    value: 'libyana-ly',
    label: 'Libyana Libya',
    country: 'LY',
    img: '/operatorLogos/libyana-ly.png',
  },
  {
    prefix: '218',
    value: 'almadar-ly',
    label: 'Almadar Libya',
    country: 'LY',
    img: '/operatorLogos/almadar-ly.png',
  },
];

export const lookup = [
  { key: 'en', value: TransactionStatus },
  { key: 'ar', value: TransactionStatusArabic },
  { key: 'no', value: TransactionStatusNorwegian },
  { key: 'da', value: TransactionStatusDutch },
  { key: 'se', value: TransactionStatusSwedish },
  { key: 'sv', value: TransactionStatusSwedish },
  { key: 'sr', value: TransactionStatusSerbian },
  // { key: "ms",value: TransactionStatusMalay },
  { key: 'my', value: TransactionStatusMalay },
  { key: 'mm', value: TransactionStatusBurmese },
  { key: 'mz', value: TransactionStatusMozambique },
];

export const lookupStatus = [
  { key: 'en', value: SubscriptionStatus },
  { key: 'ar', value: SubscriptionStatusArabic },
  { key: 'no', value: SubscriptionStatusNorwegian },
  { key: 'da', value: SubscriptionStatusDutch },
  { key: 'se', value: SubscriptionStatusSwedish },
  { key: 'sv', value: SubscriptionStatusSwedish },
  { key: 'sr', value: SubscriptionStatusSerbian },
  { key: 'my', value: SubscriptionStatusMalay },
  // { key: "my",value: SubscriptionStatusBurmese },
  { key: 'mm', value: SubscriptionStatusBurmese },
  { key: 'mz', value: SubscriptionStatusMozambique },
];

export const lookupFrequency = [
  { key: 'en', value: Frequency },
  { key: 'ar', value: FrequencyArabic },
  { key: 'no', value: FrequencyNorwegian },
  { key: 'da', value: FrequencyDutch },
  { key: 'se', value: FrequencySwedish },
  { key: 'sv', value: FrequencySwedish },
  { key: 'sr', value: FrequencySerbian },
  { key: 'my', value: FrequencyMalay },
  // { key: "my",value: FrequencyBurmese },
  { key: 'mm', value: FrequencyBurmese },
  { key: 'mz', value: FrequencyMozambique },
];

const _today = moment();
const _last2years = _today.add('years', -0);
const _endOfMonth = _today.endOf('month').format('YYYY-MM-DDT23:59:59.999'); // moment().format( "YYYY-MM-DD" );
const _startOfMonth = _today.startOf('month').format('YYYY-MM-DDT00:00:00.000');

export const today = _today;
export const last2years = _last2years;
export const endOfMonth = _endOfMonth;
export const startOfMonth = _startOfMonth;
export const Frequencies = Frequency;
export const SubscriptionStatuses = SubscriptionStatus;
export const SubscriptionStatusesMozambique = SubscriptionStatusMozambique;
export const TransactionStatuses = TransactionStatus;
export const TransactionStatusesArabic = TransactionStatusArabic;
export const TransactionStatusesNorwegian = TransactionStatusNorwegian;
export const FrequenciesArabic = FrequencyArabic;
export const FrequenciesMozambique = FrequencyMozambique;
export const SubscriptionStatusesArabic = SubscriptionStatusArabic;
export const TransactionStatusesMozambique = TransactionStatusMozambique;
export const OperatorPrefixes = OperatorPrefix;
export const OperatorCountries = OperatorCountry;
